/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MobileOnboardingInitiateRequest } from '../models/MobileOnboardingInitiateRequest';
import type { MobileOnboardingInitiateResponse } from '../models/MobileOnboardingInitiateResponse';
import type { MobileOnboardingSubmitRequest } from '../models/MobileOnboardingSubmitRequest';
import type { OnboardingFlowResponse } from '../models/OnboardingFlowResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileOnboardingService {
    /**
     * Initiate token-based mobile onboarding
     * Validate magic link token, create device invitation, and return session token.
     * @param requestBody
     * @returns MobileOnboardingInitiateResponse Successful Response
     * @throws ApiError
     */
    public static initiateMobileOnboarding(
        requestBody: MobileOnboardingInitiateRequest,
    ): CancelablePromise<MobileOnboardingInitiateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/mobile/initiate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired invitation token`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Start mobile onboarding flow
     * Start the onboarding flow via enrollment orchestrator.
     * @param xSessionToken
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static startMobileOnboarding(
        xSessionToken: string,
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/mobile/start',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            errors: {
                401: `Missing or invalid X-Session-Token header`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Submit factor response for mobile onboarding
     * Submit a factor response in the onboarding flow.
     * @param xSessionToken
     * @param requestBody
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static submitMobileOnboarding(
        xSessionToken: string,
        requestBody: MobileOnboardingSubmitRequest,
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/mobile/submit',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Missing or invalid X-Session-Token header`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Complete mobile onboarding
     * Complete mobile onboarding via enrollment orchestrator.
     * @param xSessionToken
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static completeMobileOnboarding(
        xSessionToken: string,
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/mobile/complete',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            errors: {
                401: `Missing or invalid X-Session-Token header`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
}
